class SnackbarManager {
    static listeners = [];
    
    static subscribe(listener) {
        this.listeners.push(listener);
        return () => {
            this.listeners = this.listeners.filter(l => l !== listener);
        };
    }
    
    static show(message, type = 'info', duration = 5000) {
        this.listeners.forEach(listener => {
            listener({ message, type, duration, open: true });
        });
    }
    
    static success(message, duration = 5000) {
        this.show(message, 'success', duration);
    }
    
    static error(message, duration = 5000) {
        this.show(message, 'error', duration);
    }
    
    static info(message, duration = 5000) {
        this.show(message, 'info', duration);
    }
    
    static warning(message, duration = 5000) {
        this.show(message, 'warning', duration);
    }
}

export default SnackbarManager;